import { useState } from "react";

import { useTimeout } from "usehooks-ts";

import { Pill } from "src/base-components/Pill";
import { EventConfigEnriched } from "src/clients/features-control";
import { EventPill } from "src/copilot/EventPill";

type Props = {
  event: EventConfigEnriched | null;
  delay: number;
};

export const EventMention = ({ event, delay }: Props) => {
  const [render, setRender] = useState(delay ? false : true);

  useTimeout(() => setRender(true), 1000 * delay);

  return (
    render && (
      <span className="mx-1 inline-flex">
        {event ? (
          <EventPill resource={event} />
        ) : (
          <Pill size="sm" variant="gray" fullWidth>
            <Pill.Text>Event not found</Pill.Text>
          </Pill>
        )}
      </span>
    )
  );
};
